import React from "react";
import "./info.css";
import DOMPurify from "dompurify";
import imgPlaceholder from "../../../../assets/imgPlaceholder.png";
import tvsPlaceholder from "../../../../assets/accessories_Placeholder_img.png";

function InfoModal({
  setModalVisiblity,
  modalVisiblity,
  data,
  onPress,
  add,
  disable,
}) {
  function createMarkup(html) {
    return {
      __html: DOMPurify.sanitize(html),
    };
  }
  return (
    <>
      {modalVisiblity && (
        <div className="info_modal">
          <div className="info_modal_container">
            <div className="container_of_modal">
              <img
                className="modal_img"
                src={data?.Images[0] || imgPlaceholder}
                onError={(e) => {
                  e.target.src = tvsPlaceholder;
                }}
                alt="Product"
              />
              <div
                className="modal_desc mediumFont"
                dangerouslySetInnerHTML={createMarkup(data?.Description)}
              ></div>
              <div className="items_div lightFont">
                <div>{data?.Name}</div>
                <span>₹{data?.Price}/-</span>
              </div>
              <div className="button_group_info">
                <button
                  className="close_button"
                  onClick={() => setModalVisiblity(false)}
                >
                  Cancel
                </button>
                <button
                  className="add_button"
                  style={{
                    opacity: disable && 0.5,
                    pointerEvents: disable && "none",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setModalVisiblity(false);
                    onPress();
                  }}
                >
                  {add ? "Remove" : "Add"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default InfoModal;
